(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["quote-button"] && !Shopify.designMode) return;
  try {
    class QuoteButtonComponent extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      const data = this.querySelector('script[type="application/json"]');
      try { this.variants = JSON.parse(data.textContent); } catch (e) { this.variants = {}; }
      this.last = '';
      this.update();
      this.timer = setInterval(() => this.update(), 400);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    update() {
      if (location.href === this.last) return;
      this.last = location.href;
      const id = new URL(location.href).searchParams.get('variant');
      const variant = id && this.variants[id] ? this.variants[id] : '';
      const text = [this.dataset.intro, this.dataset.product, variant && '(' + variant + ')', this.dataset.url + (id ? '?variant=' + id : '')]
        .filter(Boolean).join(' ');
      this.link.href = 'https://wa.me/' + this.dataset.number + '?text=' + encodeURIComponent(text);
    }
  }
  if (!customElements.get('quote-button-component')) customElements.define('quote-button-component', QuoteButtonComponent);
  } catch(e) { console.error(e); }
})();

})();
